export const Titles = {
  TemporalVariation: "Variação temporal",
  OrderQuantity: "Quantidade de pedidos",
  TotalSpent: "Total gasto",
  DaysWithoutOrder: "Dias sem pedir",
  Birthday: "Aniversário",
  AverageTicket: "Ticket médio",
  OrderValue: "Valor do pedido",
  Age: "Idade",
  CustomerName: "Nome do cliente",
  CustomerEmail: "Email do cliente",
  CustomerPhone: "Telefone do cliente",
  CustomerDoc: "CPF do cliente",
  CustomerCreatedAt: "Cadastro do cliente",
  RfvFrequency: "Frequência de RFV"
};
